// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"37":"76d8c668","293":"component---src-pages-index-js","687":"fea29d9f"}[chunkId] + "-" + {"37":"6faaf32f3972c8ef3588","293":"6b101c40657c09ab6fe6","687":"ac875f24dfcaa19f008a"}[chunkId] + ".js";
};